import { Api } from '@allswipes/client';

/**
 * Клиент админки.
 *
 * Ключ токена свой: сессия сотрудника платформы не должна смешиваться с
 * сессией партнёра даже в одном браузере — у них разные права и разный вход.
 */
export const api = new Api(import.meta.env.VITE_API_URL ?? '', 'allswipes-admin-token');
